import { useState, useEffect } from "react";
import useDebounce from "./useDebounce";

export default function useDropdownPosition(
  containerRef: React.RefObject<HTMLDivElement>
) {
  const [position, setPosition] = useState<"above" | "below">("below");
  const [trigger, setTrigger] = useState(0);

  // Debounce the trigger state changes
  const debouncedTrigger = useDebounce(trigger.toString(), 100);

  useEffect(() => {
    const calculatePosition = () => {
      if (!containerRef.current) return;

      const containerRect = containerRef.current.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      const spaceBelow = viewportHeight - containerRect.bottom;
      const spaceAbove = containerRect.top;
      const optionsHeight = 160; // Approximate height of options

      setPosition(
        spaceBelow < optionsHeight && spaceAbove > spaceBelow
          ? "above"
          : "below"
      );
    };

    const handleResize = () => {
      setTrigger((prev) => prev + 1);
    };

    const handleScroll = () => {
      setTrigger((prev) => prev + 1);
    };

    calculatePosition();
    window.addEventListener("resize", handleResize);
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("scroll", handleScroll);
    };
  }, [containerRef]);

  // Recalculate position when debounced trigger changes
  useEffect(() => {
    if (!containerRef.current) return;

    const containerRect = containerRef.current.getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    const spaceBelow = viewportHeight - containerRect.bottom;
    const spaceAbove = containerRect.top;
    const optionsHeight = 160;

    setPosition(
      spaceBelow < optionsHeight && spaceAbove > spaceBelow ? "above" : "below"
    );
  }, [debouncedTrigger, containerRef]);

  return position;
}
